import styled from 'styled-components'

export const EditWrapper = styled.div``

export const EditHeadingSection = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
`

export const EditHeading = styled.h3``

export const EditTable = styled.table`
  width: 100%;
`

export const EditTHead = styled.thead`
  background-color: #666;
  color: #f5f5f5;
  border-left: 1px solid #666;
  border-right: 1px solid #666;
`

export const EditTBody = styled.tbody`
  vertical-align: top;
  background-color: #f5f5f5;
  border-left: 1px solid #ccc;
  border-right: 1px solid #ccc;

  & tr {
    border-bottom: 1px solid #ccc;
  
    &:nth-child(even) {
      background-color: #ececec;
    }
  }
`

export const EditTR = styled.tr``

export const EditTH = styled.th`
  padding: 6px 3px;
`

export const DFlex = styled.div`
  display: flex;
  align-items: center;

  & button {
    margin-left: 5px;
  }

  &:not(:first-child) {
    margin-top: 5px;
  }
`

export const EditTD = styled.td`
  padding: 6px 3px;
  width: ${p => p.moveButtons ? '58px' : 'auto'};

  ${p => p.checkbox && `
    width: 1px;
    text-align: center;
  `}
`

export const MoveButtons = styled.div`
  max-width: fit-content;
  display: flex;
  justify-content: flex-start;
`